// Print-to-PDF for reports. We open a standalone, RTL-aware document in a new
// window and trigger the browser's print dialog — the user picks "Save as PDF".
// This sidesteps embedding Hebrew fonts into a JS PDF generator: the browser
// renders Hebrew/RTL natively and produces a clean, paginated document.

export function escapeHtml(value) {
  if (value === null || value === undefined) return ''
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

const PRINT_CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Assistant:wght@400;600;700;800&display=swap');
  * { box-sizing: border-box; }
  body { font-family: 'Assistant', system-ui, Arial, sans-serif; color: #111; margin: 28px; }
  h1 { font-size: 22px; font-weight: 800; margin: 0 0 4px; }
  .sub { color: #555; font-size: 13px; margin: 0 0 2px; }
  .gen { color: #888; font-size: 11px; margin: 0 0 18px; }
  table { width: 100%; border-collapse: collapse; font-size: 12.5px; margin-bottom: 18px; }
  th { text-align: start; font-size: 11px; text-transform: uppercase; letter-spacing: .03em;
       color: #444; border-bottom: 2px solid #222; padding: 8px 10px; }
  td { padding: 8px 10px; border-bottom: 1px solid #ddd; vertical-align: top; }
  td.num, th.num { text-align: end; font-variant-numeric: tabular-nums; white-space: nowrap; }
  .sub-dates { color: #888; font-size: 11px; }
  .summary { margin-top: 6px; border: 1px solid #222; border-radius: 6px; overflow: hidden; }
  .summary .srow { display: flex; justify-content: space-between; padding: 10px 14px; font-size: 13px; }
  .summary .srow + .srow { border-top: 1px solid #ddd; }
  .summary .total { background: #16205211; font-weight: 800; font-size: 15px; }
  @media print { body { margin: 12mm; } a { display: none; } }
`

/**
 * @param {Object} opts
 * @param {string} opts.title       Main heading.
 * @param {string} [opts.subtitle]  Period / scope line.
 * @param {string} [opts.generated] "Generated on …" line.
 * @param {string} [opts.dir]       'rtl' | 'ltr'.
 * @param {string} opts.bodyHtml    Pre-built table + summary HTML.
 */
export function printReport({ title = 'Report', subtitle = '', generated = '', dir = 'ltr', bodyHtml = '' }) {
  const win = window.open('', '_blank', 'width=900,height=700')
  if (!win) return
  const lang = dir === 'rtl' ? 'he' : 'en'
  win.document.write(
    `<!doctype html><html dir="${dir}" lang="${lang}"><head><meta charset="utf-8">` +
    `<title>${escapeHtml(title)}</title><style>${PRINT_CSS}</style></head><body>` +
    `<h1>${escapeHtml(title)}</h1>` +
    (subtitle ? `<p class="sub">${escapeHtml(subtitle)}</p>` : '') +
    (generated ? `<p class="gen">${escapeHtml(generated)}</p>` : '') +
    bodyHtml +
    `<script>window.onload=function(){setTimeout(function(){window.print()},250)}</script>` +
    `</body></html>`
  )
  win.document.close()
}
